import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Typography } from 'ck-ui';
import { useSash } from './hooks/useSash';
import styles from './InTileFooterSash.module.scss';

const InTileFooterSash = ({ text, bgColor, tags, extraTags }) => {
  const { topSash } = useSash([...tags, ...extraTags]);

  if (text) {
    return (
      <div className={styles.root} style={{ backgroundColor: bgColor }}>
        <p className={styles.text}>{text}</p>
      </div>
    );
  }

  return topSash && topSash.label ? (
    <Typography
      className={classnames('sash-base', styles.topSash)}
      weight={700}
      align="centered"
    >
      {topSash.label}
    </Typography>
  ) : null;
};

InTileFooterSash.propTypes = {
  bgColor: PropTypes.string,
  text: PropTypes.string,
  tags: PropTypes.array,
  extraTags: PropTypes.array,
};

InTileFooterSash.defaultProps = {
  bgColor: '#000000',
  text: null,
  tags: [],
  extraTags: [],
};

export { InTileFooterSash };
